export const getRandomColor = () => {
  const getRgb = () => Math.floor(Math.random() * 256)

  const rgbToHex = (r: number, g: number, b: number) => {
    const hexCode = [r, g, b]
      .map((x) => {
        const hex = x.toString(16)
        return hex.length === 1 ? `0${hex}` : hex
      })
      .join('')

    return `#${hexCode}`
  }

  const handleColorGenerate = () => {
    const color = {
      r: getRgb(),
      g: getRgb(),
      b: getRgb(),
    }

    return rgbToHex(color.r, color.g, color.b)
  }

  return handleColorGenerate()
}
